import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_12: FaireProductEntity = {
  token: "legacy_prod_abbott-12",
  type: "product",
  name: "Grey LED Pillar Candle 2x4 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/947b396c78fab5629a30eb9cddb1045fc1d59d3e1d59017dc1b7a278cae5aa35.jpeg",
  priceDollars: 8,
  msrpDollars: 16,
  subcategory: "Pillar Candles",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_candles-holders"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
